import { render, staticRenderFns } from "./GrupoProdutoManage.vue?vue&type=template&id=6977d7b7&scoped=true"
import script from "./GrupoProdutoManage.vue?vue&type=script&lang=js"
export * from "./GrupoProdutoManage.vue?vue&type=script&lang=js"
import style0 from "./GrupoProdutoManage.vue?vue&type=style&index=0&id=6977d7b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6977d7b7",
  null
  
)

export default component.exports